import * as THREE from 'three';

export function startAnimationLoop(
  camera: THREE.PerspectiveCamera,
  directionalLight: THREE.DirectionalLight,
  renderer: THREE.WebGLRenderer,
  scene: THREE.Scene,
  setAnimationId: (animationId: number) => void,
  onAfterRender?: () => void,
): void {
  const animate = () => {
    setAnimationId(requestAnimationFrame(animate));
    const dir = camera.getWorldDirection(new THREE.Vector3());
    directionalLight.position.copy(dir.multiplyScalar(-1));
    renderer.render(scene, camera);
    onAfterRender?.();
  };

  animate();
}
